/**
 * @Author: v_jppjpeng
 * @Date: 2023-2-9 16:51:20
 * @Explain: 占位符
 */
import http from '../http';
import httpV2 from '../http-v2';
// type
import type { FilterTypeEnum } from '@/components/common/filterSelect/data.d';
import type { FieldResTypeEnum } from '@/pages/contactManage/fieldSettings/data.d';
import type { HttpResponse } from '../data.d';
import type {
  GetActivityListItemType,
  GetChannelGameInfoReqType,
  GetChannelGameInfoResType,
  GetDistributionActivityResType,
  ImportKeysReqType,
  ImportKeysResType,
} from './data.d';

const MODEL = '/variable';

export default {
  // 上传固定变量文件
  uploadFixedFileApi: `${http.defaults.baseURL + MODEL}/create-static-new`,
  // 列表
  getList(data: Record<any, any>) {
    return httpV2.post(`${MODEL}/list`, data);
  },
  // 获取 placeholder 列表
  getPholderList(data: Record<any, any>) {
    return http.post(`${MODEL}/list-simple`, data);
  },
  // 创建资源码 或 保存导入的资源码文件
  onAddStatic(data: Record<any, any>) {
    return http.post(`${MODEL}/save-static`, data);
  },
  // 编辑资源码(仅在更改描述时调用)
  onEdit(data: Record<any, any>) {
    return http.post(`${MODEL}/edit`, data);
  },
  // // 添加、编辑动态 (动态资源码已归入用户属性,因此此接口不会被调用)
  // onAddDynamic(data: Record<any, any>) {
  //   return http.post(`${MODEL}/modify-dynamic`, data);
  // },
  // 删除
  onDel(data: Record<any, any>) {
    return http.post(`${MODEL}/delete`, data);
  },
  // 详情
  getDetails(data: Record<any, any>) {
    return http.post(`${MODEL}/detail`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 详情 - 获取变量列表
  getVarList(data: Record<any, any>) {
    return httpV2.post(`${MODEL}/detail-list`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 获取变量使用情况
  getVarUsage(data: Record<any, any>) {
    return http.post(`${MODEL}/get-variable-is-use`, data);
  },
  // 获取模板中的变量
  getTempVar(data: Record<any, any>) {
    return http.post(`${MODEL}/get-template-variable`, data);
  },
  // 获取占位符讯息
  getVarInfo(data: Record<any, any>) {
    return http.post(`${MODEL}/get_variable_msg`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 多语言模板 - 获取模板中的占位符
  getAllTempVar(data: Record<any, any>) {
    return http.post(`${MODEL}/get_batch_template_variable`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 获取全部资源码或者联系人字段
  // type: 0-全部 1-资源码 2-动态码（好像已废弃） 3-联系人字段
  getResourceCodesOrContactFields(data: {
    type: FilterTypeEnum;
    isWhatsapp?: boolean;
    // 是否展示全部功能类型字段 1: 全部attribute 0: 过滤掉内置类型attribute
    isAllType?: FieldResTypeEnum;
  }) {
    return httpV2.post(`${MODEL}/list_attributes`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 查询选中资源码兑换内容ID对应的游戏信息
  getChannelGameInfo(
    data: GetChannelGameInfoReqType,
  ): Promise<HttpResponse<GetChannelGameInfoResType>> {
    return http.post(`${MODEL}/channel_game_info`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 资源码导入
  onImportKeys(
    data: ImportKeysReqType,
  ): Promise<HttpResponse<ImportKeysResType>> {
    return http.post(`${MODEL}/create-static-new`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
      params: { isPackage: 'N' },
    });
  },
  // 获取按活动分布数据
  getDistributionActivity(data: {
    id: number;
    name: string;
    type: number;
  }): Promise<HttpResponse<GetDistributionActivityResType>> {
    return http.post(`${MODEL}/distribution_activity`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 查询资源码使用方信息
  getActivityList(data: any): Promise<HttpResponse<GetActivityListItemType>> {
    return http.post(`${MODEL}/activity_list`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 导出资源码
  resCreateExportKeys(
    data: Record<any, any>,
  ): Promise<HttpResponse<GetActivityListItemType>> {
    return http.post(`${MODEL}/create_export_history`, data, {
      params: { switchReqToUnderline: true },
    });
  },
};